import { WALLET_URL } from 'constants/config';
import type { PaymentMethod } from 'models/paymentMethod';
import { fetchWithAuthentication } from 'utils/fetchJson/fetchJson';

const WalletService = {
  fetchPaymentMethods: (): Promise<PaymentMethod[]> => {
    const options = { method: 'GET' };
    const url = `${WALLET_URL}/payment_methods`;

    return fetchWithAuthentication(url, options);
  },

  removeCreditCard: (token: string) => {
    const options = { method: 'DELETE' };

    const url = `${WALLET_URL}/${token}`;

    return fetchWithAuthentication(url, options);
  },
};

export { WalletService };
